module.exports = __webpack_public_path__ + "img/040-069.1c742c06.png";